import React from "react";
import { useWs } from "@/context/WorkspaceContext";
import { KbReader, CLIENT_KB_API } from "@/components/KbReader";

export default function KnowledgeBase() {
  const ws = useWs();
  return <KbReader basePath={`/${ws.slug}/knowledge`} endpoints={CLIENT_KB_API} accent={ws?.workspace?.accent_color || "#723FFF"} />;
}
